import React from "react";
import { API_URLS } from '../../../../helpers/api/API_URLS';
import { basicGET, basicJSONPOST, basicJSONDELETE } from '../../../../helpers/api/fetchParams';

import AccordianTitle from "../../../../helpers/uiComponents/Accordian";
import CatalogControls from "./Catalogs/CatalogControls";
import Category from "../../../../helpers/uiComponents/CatalogCategory";
import { ActionTabs } from "../../../../helpers/uiComponents/ActionTabs";
import { InputRow } from "../../../../helpers/uiComponents/InputRow";
import { addClient } from "../../../../data/serviceClients";
import { hideMessage, showMessage } from "../../../../helpers/uiFunctions/uiActions";

export class Catalogs extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			activeCatalogs: [],
			allCatalogs: [],
			clientList: [],
			currentClient: this.props.currentClient
		}
		this.save = this.save.bind(this);
		this.isAll = this.isAll.bind(this);
		this.applyAll = this.applyAll.bind(this);
		this.handleUpdate = this.handleUpdate.bind(this);
	}

	componentDidMount() {
		this.getAllCatalogs();
		var activeClients = this.props.clients.filter( client => { return client.status === "active"; });
		let list = [{"name": "Do Not Use - OFF", "value": "null"},];
		for (var i = 0; i < activeClients.length; i++) {
			list.push({"name": activeClients[i].name, "value": activeClients[i].clientCode,},)
		}
		
		this.setState({
			clientList: list,
		});
	}

	getAllCatalogs() {
		let allItems = [];

		fetch(API_URLS.ALLSFNCATALOGS, basicGET(localStorage.getItem("token")))
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('failed to fetch all catalogs in getAllCatalogs in Catalogs.js ...'); }
		}).then(data => {
			// console.log(data);

			for (var i = data.length - 1; i >= 0; i--) {
				data[i].active = false;
				data[i].id = null;

				if (data[i].dealerBrand === "") {
					data[i].dealerBrand = null;
				}
				if (data[i].brand === "") {
					data[i].brand = null;
				}
				if (data[i].manufacturer === "") {
					data[i].manufacturer = null;
				}
			}

			allItems = data;

			return fetch(API_URLS.API+"/"+this.props.currentClient.clientCode+"/catalog", basicGET(localStorage.getItem("token")));
		})
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('failed to fetch active catalogs in getActiveCatalogs in Catalogs.js ...'); }
		})
		.then(data => {
			var active = data.result

			for (var i = active.length - 1; i >= 0; i--) {
				active[i].active = true;

				if (active[i].dealerBrand === "") {
					active[i].dealerBrand = null;
				}
				if (active[i].brand === "") {
					active[i].brand = null;
				}
				if (active[i].manufacturer === "") {
					active[i].manufacturer = null;
				}
			}
			this.setState({activeCatalogs: active});
		})
		.then(() => {
			var activeItem = this.state.activeCatalogs;

			for (var i = allItems.length - 1; i >= 0; i--) {
				var pt = allItems[i].productType;
				var mn = allItems[i].manufacturer;
				var br = allItems[i].brand;
				var db = allItems[i].dealerBrand;

				for (var x = activeItem.length - 1; x >= 0; x--) {
					if (
						activeItem[x].productType === pt &&
						activeItem[x].manufacturer === mn &&
						activeItem[x].brand === br &&
						activeItem[x].dealerBrand === db
					) {
						delete allItems[i]
					}
				}
			}
			this.setState({allCatalogs: allItems});
		})
		.catch(error => console.log(error));
	}

	isAll(prodType) {
		var activeCatalogs = this.state.activeCatalogs;
		var checked = false;
		for (var i = activeCatalogs.length - 1; i >= 0; i--) {
			if (
				activeCatalogs[i].productType === prodType &&
				(activeCatalogs[i].manufacturer === "" || activeCatalogs[i].manufacturer === null ) &&
				(activeCatalogs[i].brand === "" || activeCatalogs[i].brand === null ) &&
				(activeCatalogs[i].dealerBrand === "" || activeCatalogs[i].dealerBrand === null )
			) {
				checked = "checked";
				break;
			}
		}
		return checked;
	}
	applyAll(prodType, checked) {
		var activeCatalogs = this.state.activeCatalogs;
		let siteCode, i;
		if (this.props.currentClient.clientCode === "fliq") {
			siteCode = "flbl";
		} else {
			siteCode = "www";
		}

		if (checked === "checked") {
			console.log("turn off");
			// currently checked
			// save specifics, delete all
			for (i = activeCatalogs.length - 1; i >= 0; i--) {
				if ( activeCatalogs[i].productType === prodType) {
					this.save(
					activeCatalogs[i].productType,
					activeCatalogs[i].manufacturer,
					activeCatalogs[i].brand,
					activeCatalogs[i].dealerBrand,
					activeCatalogs[i].id,
					siteCode, true);
				}
			}
		} else {
			console.log("turn on");
			// currently not checked
			// save all, delete specifics
			this.save(
				prodType,
				"",
				"",
				"",
				null,
				siteCode, false);

			for (i = activeCatalogs.length - 1; i >= 0; i--) {
				if ( activeCatalogs[i].productType === prodType) {
					this.save(
					activeCatalogs[i].productType,
					activeCatalogs[i].manufacturer,
					activeCatalogs[i].brand,
					activeCatalogs[i].dealerBrand,
					activeCatalogs[i].id,
					siteCode, true);
				}
			}
		}

	}

	save(pt, man, br, db, id, sitecode, checked) {
		showMessage("Saving Catalogs...");
		let body = {};
		body["productType"] = pt;
		body["manufacturer"] = man;
		body["brand"] = br;
		body["dealerBrand"] = db;
		if (id) {
			body["id"] = id;
		}

		let params = basicJSONPOST(localStorage.getItem("token"), body);
		if (checked) {
			params = basicJSONDELETE(localStorage.getItem("token"), body);
		}
		var fetchUrl = API_URLS.API+this.props.currentClient.clientCode+'/'+sitecode+API_URLS.listCatalogs+"/spec";
		
		// console.log(fetchUrl);
		// console.log(params);
		fetch(fetchUrl, params)
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong ...'); }
		})
		.then(data => {
			console.log(data);
			hideMessage(data.success);

/*
			var Http = new XMLHttpRequest();
			var url = 'https://sfn.mm-api.agency/task/catalog/'+this.props.currentClient.clientCode;
			Http.open("GET", url);
			Http.send();

			Http.onreadystatechange=(e)=> {
				console.log(Http.responseText);
			}
*/
			// reload client to show updated realtime specs...
			this.getAllCatalogs();
		})
		.catch(error => console.log(error));
	}
	handleUpdate(e) {
		var key = e.target.name;
		var value = e.target.value;
		var subArr = null;

		if (key.includes(".")) {
			subArr = key.split('.')[0];
			key = key.split('.')[1];
		}

		var type = e.target.type;
		if (type === "checkbox") {
			value = e.target.checked
		}
		if (key === "altProductClientCode" && value === "null") {
			value = null;
		}
		var newState = this.props.currentClient
		newState[key] = value
        this.setState({
			currentClient: newState,
		});
		var updateClient = this.props.updateClient
        updateClient(key, value, subArr);
		this.saveclient(newState)
	}
	saveclient(data) {
		showMessage("Updating 'Use Alternate Catalog Selections'...")
		addClient(data).then(response => {
			hideMessage(response.success);
		});
	}
	

	render() {
		const { allCatalogs, activeCatalogs, clientList } = this.state;
		let currentClient = this.props.currentClient;
		let siteCode;
		if (this.props.currentClient.clientCode === "fliq") {
			siteCode = "flbl";
		} else {
			siteCode = "www";
		}
		
		return(
			<div className="input-group">
				<AccordianTitle title={"Product Catalogs"} />
				<div className="accordian-body">
					{(currentClient) && (
						<React.Fragment>
							<InputRow
								onChange={this.handleUpdate}
								label="Use Alternate Catalog Selections From Other Client Configuration?"
								type="select"
								value={currentClient.altProductClientCode}
								property="altProductClientCode"
								id="altProductClientCode"
								options={clientList}
							/>
						</React.Fragment>
					)}
					{(currentClient) && (
						(currentClient.altProductClientCode !== null && currentClient.altProductClientCode !== "null") ? (
							<React.Fragment>
							<p>This client ({currentClient.name}) is currently using the catalogs from clientCode {currentClient.altProductClientCode}.</p>
							<p>These two clients display the exact same catalogs on their websites at all times</p>
							<br/>
							<p>To update the catalogs for this client, edit the catalog selections for the clientCode {currentClient.altProductClientCode}.</p>
							<br/>
							<p>Clear the dropdown to allow this client ({currentClient.name}) to have their own catalog selections.</p>
							</React.Fragment>
						) : (
							<React.Fragment>
								<InputRow
									onChange={this.handleUpdate}
									label="Catalog Data Source"
									type="select"
									value={currentClient.dataSource}
									property="dataSource"
									id="dataSource"
									hideSelectOption="true"
									options={[
										{ "name": "sfn", "value": "sfn"},
										{ "name": "products", "value": "products"}
									]}
								/>
								<CatalogControls
									clientCode={this.props.currentClient.clientCode}
									siteCode={siteCode}
									dataSource={this.props.currentClient.dataSource}
								/>
								<ActionTabs
									id={"catalog"}
									tabs={[
										{
											"id":"active",
											"name": "Active Catalogs"
										},{
											"id":"available",
											"name": "Available Catalogs"
										}
									]}
								/>
								<div id="catalog-inputs">
									<div id={"catalog-active"} className={"tab catalog-active active"}>

										<Category
											catalogs={activeCatalogs.filter( cat => { return (cat.productType === "bamboo" && cat.manufacturer !== "shaw"); })}
											category={"bamboo"}
											save={this.save}
											siteCode={siteCode}
										/>
										<Category
											catalogs={activeCatalogs.filter( cat => { return (cat.productType === "carpet" && cat.manufacturer !== "shaw"); })}
											category={"carpet"}
											save={this.save}
											siteCode={siteCode}
										/>
										<Category
											catalogs={activeCatalogs.filter( cat => { return (cat.productType === "hardwood" && cat.manufacturer !== "shaw"); })}
											category={"hardwood"}
											save={this.save}
											siteCode={siteCode}
										/>
										<Category
											catalogs={activeCatalogs.filter( cat => { return (cat.productType === "laminate" && cat.manufacturer !== "shaw"); })}
											category={"laminate"}
											save={this.save}
											siteCode={siteCode}
										/>
										<Category
											catalogs={activeCatalogs.filter( cat => { return (cat.productType === "lvt" && cat.manufacturer !== "shaw"); })}
											category={"lvt"}
											save={this.save}
											siteCode={siteCode}
										/>
										<Category
											catalogs={activeCatalogs.filter( cat => { return (cat.productType === "sheet" && cat.manufacturer !== "shaw"); })}
											category={"sheet"}
											save={this.save}
											siteCode={siteCode}
										/>
										<Category
											catalogs={activeCatalogs.filter( cat => { return (cat.productType === "tile" && cat.manufacturer !== "shaw"); })}
											category={"tile"}
											save={this.save}
											siteCode={siteCode}
										/>
										<Category
											catalogs={activeCatalogs.filter( cat => { return (cat.productType === "rugs" && cat.manufacturer !== "shaw"); })}
											category={"rugs"}
											save={this.save}
											siteCode={siteCode}

											isAll={this.isAll}
											applyAll={this.applyAll}
										/>
										<Category
											catalogs={activeCatalogs.filter( cat => { return (cat.productType === "paint" && cat.manufacturer !== "shaw"); })}
											category={"paint"}
											save={this.save}
											siteCode={siteCode}
										/>
									</div>

									<div id={"catalog-available"} className={"tab catalog-available"}>
										<Category
											catalogs={allCatalogs.filter( cat => { return (cat.productType === "accessory" && cat.manufacturer !== "shaw"); })}
											category={"accessory"}
											save={this.save}
											siteCode={siteCode}
										/>
										<Category
                                            catalogs={allCatalogs.filter( cat => { return (cat.productType === "bamboo" && cat.manufacturer !== "shaw"); })}
                                            category={"bamboo"}
                                            save={this.save}
                                            siteCode={siteCode}
                                        />
										<Category
											catalogs={allCatalogs.filter( cat => { return (cat.productType === "carpet" && cat.manufacturer !== "shaw"); })}
											category={"carpet"}
											save={this.save}
											siteCode={siteCode}
										/>
										<Category
											catalogs={allCatalogs.filter( cat => { return (cat.productType === "hardwood" && cat.manufacturer !== "shaw"); })}
											category={"hardwood"}
											save={this.save}
											siteCode={siteCode}
										/>
										<Category
											catalogs={allCatalogs.filter( cat => { return (cat.productType === "laminate" && cat.manufacturer !== "shaw"); })}
											category={"laminate"}
											save={this.save}
											siteCode={siteCode}
										/>
										<Category
											catalogs={allCatalogs.filter( cat => { return (cat.productType === "lvt" && cat.manufacturer !== "shaw"); })}
											category={"lvt"}
											save={this.save}
											siteCode={siteCode}
										/>
										<Category
											catalogs={allCatalogs.filter( cat => { return (cat.productType === "sheet" && cat.manufacturer !== "shaw"); })}
											category={"sheet"}
											save={this.save}
											siteCode={siteCode}
										/>
										<Category
											catalogs={allCatalogs.filter( cat => { return (cat.productType === "tile" && cat.manufacturer !== "shaw"); })}
											category={"tile"}
											save={this.save}
											siteCode={siteCode}
										/>
										<Category
											catalogs={allCatalogs.filter( cat => { return (cat.productType === "rugs" && cat.manufacturer !== "shaw"); })}
											category={"rugs"}
											save={this.save}
											siteCode={siteCode}

											isAll={this.isAll}
											applyAll={this.applyAll}
										/>
										<Category
											catalogs={allCatalogs.filter( cat => { return (cat.productType === "paint" && cat.manufacturer !== "shaw"); })}
											category={"paint"}
											save={this.save}
											siteCode={siteCode}
										/>
									</div>
								</div>
							</React.Fragment>
						)
					)}
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/component_client/components/ClientProfile/ProfileComponents/ProductCatalogs.js